import { createSelector } from '@ngrx/store';
import { getOrderSummary } from '../../../onlineOrder/selectors/getOrderSummary';
import { getAccountBalance } from '../../../members/selectors/getAccountBalance';
import { isAccountChargeSelected } from '../../../creditCards/selectors/isAccountChargeSelected';

export const isPaymentDisabledForAccountCharge = createSelector(
    getAccountBalance,
    getOrderSummary,
    isAccountChargeSelected,
    (accountBalance, orderSummary, accountChargeSelected) => {
        const total = orderSummary?.Total;
        const availableBalance = accountBalance.data?.AvailableBalance;

        return accountChargeSelected && total != null && availableBalance != null && availableBalance < total;
    },
);
